var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 103,
    viewBox: "0 0 85 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_512_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7888 4.85001C46.6588 3.66001 45.1388 3 43.5088 3C40.9588 3 38.7088 4.62001 37.9088 7.04001L36.5388 11.18L14.3088 3.82001C13.6988 3.62001 13.0688 3.52 12.4388 3.52C10.0988 3.52 7.97878 4.92001 7.03878 7.10001C6.09878 9.29001 6.52878 11.73 8.17878 13.47L36.2588 43.15C37.3888 44.34 38.9088 45 40.5388 45C43.0888 45 45.3388 43.38 46.1388 40.95L47.5088 36.81L69.7388 44.17C70.3488 44.37 70.9788 44.47 71.6088 44.47C73.9488 44.47 76.0688 43.07 77.0088 40.89C77.9488 38.7 77.5188 36.26 75.8688 34.52L47.7888 4.84V4.85001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5285 41.7195C39.8085 41.7195 39.1385 41.4296 38.6385 40.8996L10.5585 11.2195C9.82852 10.4495 9.63852 9.36955 10.0485 8.40955C10.4685 7.43955 11.3985 6.81955 12.4285 6.81955C12.7085 6.81955 12.9885 6.86955 13.2685 6.95955L38.6285 15.3495L41.0285 8.07954C41.3785 7.00954 42.3785 6.28955 43.5085 6.28955C44.2285 6.28955 44.8985 6.57954 45.3985 7.10954L73.4785 36.7896C74.2085 37.5596 74.3985 38.6395 73.9885 39.5995C73.5685 40.5595 72.6385 41.1895 71.6085 41.1895C71.3285 41.1895 71.0485 41.1395 70.7685 41.0495L45.4085 32.6595L42.9985 39.9296C42.6485 40.9995 41.6485 41.7195 40.5185 41.7195H40.5285Z",
    fill: "url(#paint0_linear_512_1977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5084 7.58975C43.8484 7.58975 44.1884 7.71976 44.4584 7.99976L72.5384 37.6798C73.3684 38.5598 72.6684 39.8998 71.6084 39.8998C71.4684 39.8998 71.3284 39.8798 71.1784 39.8298L44.5984 31.0298L41.7884 39.5198C41.5984 40.0998 41.0684 40.4198 40.5384 40.4198C40.1984 40.4198 39.8584 40.2898 39.5884 40.0098L11.5084 10.3298C10.6784 9.44976 11.3684 8.10976 12.4384 8.10976C12.5784 8.10976 12.7184 8.12976 12.8684 8.17976L39.4484 16.9798L42.2584 8.48976C42.4484 7.90976 42.9784 7.58975 43.5084 7.58975ZM43.5084 5.00977C41.8184 5.00977 40.3384 6.07976 39.8084 7.67976L37.8084 13.7198L13.6784 5.72977C13.2684 5.59977 12.8484 5.52975 12.4384 5.52975C10.8984 5.52975 9.49837 6.45976 8.87837 7.89977C8.25837 9.34976 8.54837 10.9598 9.62837 12.1098L37.7084 41.7898C38.4484 42.5798 39.4584 43.0098 40.5384 43.0098C42.2284 43.0098 43.7084 41.9398 44.2384 40.3398L46.2384 34.2998L70.3684 42.2898C70.7784 42.4198 71.1984 42.4898 71.6084 42.4898C73.1484 42.4898 74.5484 41.5598 75.1684 40.1198C75.7884 38.6698 75.4984 37.0598 74.4184 35.9098L46.3384 6.22977C45.5984 5.43977 44.5884 5.00977 43.5084 5.00977Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0395 63.17L28.1195 62.71C26.0395 62.71 24.1495 63.77 23.0795 65.55C21.9995 67.33 21.9395 69.49 22.8995 71.34L24.9195 75.2L4.16947 86.06C1.73947 87.34 0.529468 89.99 1.16947 92.66C1.80947 95.33 4.08947 97.1499 6.83947 97.1799L47.7195 97.64C49.8295 97.64 51.7295 96.58 52.8095 94.8C53.8895 93.02 53.9495 90.86 52.9895 89.01L50.9695 85.15L71.7195 74.29C74.1495 73.01 75.3595 70.36 74.7195 67.69C74.0795 65.02 71.7995 63.2 69.0495 63.17H69.0395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87874 93.89C5.66874 93.88 4.65874 93.07 4.37874 91.89C4.09874 90.71 4.62874 89.54 5.69874 88.97L29.3587 76.58L25.8087 69.8C25.3787 68.98 25.4087 68.03 25.8887 67.24C26.3687 66.45 27.1987 65.98 28.1187 65.98L68.9987 66.44C70.2087 66.45 71.2187 67.26 71.4987 68.44C71.7787 69.62 71.2487 70.79 70.1787 71.36L46.5187 83.75L50.0687 90.53C50.4987 91.34 50.4687 92.3 49.9887 93.09C49.5087 93.88 48.6787 94.35 47.7587 94.35L6.87874 93.89Z",
    fill: "url(#paint1_linear_512_1977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.119 67.29C28.119 67.29 28.129 67.29 28.139 67.29L68.989 67.75C70.349 67.77 70.789 69.59 69.579 70.23L44.769 83.22L48.919 91.1499C49.379 92.0299 48.739 93.07 47.759 93.07C47.759 93.07 47.749 93.07 47.739 93.07L6.889 92.61C5.529 92.59 5.089 90.77 6.299 90.13L31.109 77.14L26.959 69.21C26.499 68.33 27.139 67.29 28.119 67.29ZM28.119 64.71C26.749 64.71 25.499 65.41 24.789 66.59C24.079 67.77 24.029 69.2 24.669 70.41L27.619 76.05L5.099 87.84C3.489 88.68 2.689 90.43 3.119 92.2C3.539 93.97 5.049 95.17 6.859 95.19L47.709 95.6499C49.129 95.6499 50.369 94.9499 51.089 93.7699C51.799 92.5899 51.849 91.16 51.209 89.95L48.259 84.31L70.779 72.52C72.389 71.68 73.189 69.93 72.759 68.16C72.329 66.39 70.829 65.19 69.009 65.17L28.159 64.71H28.149H28.119Z",
    fill: "#1D074F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_512_1977",
    x: 0,
    y: 0,
    width: 84.498,
    height: 102.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_512_1977"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_512_1977",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_1977",
    x1: 42.0185,
    y1: 6.29955,
    x2: 42.0185,
    y2: 41.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0FD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_512_1977",
    x1: 37.9387,
    y1: 66,
    x2: 37.9387,
    y2: 94.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroup3);
export default __webpack_public_path__ + "static/media/ic_group-3.3edf01e6531cbb6a285c29f3dc12e79f.svg";
export { ForwardRef as ReactComponent };